import type { ReactNode } from "react";
import "./Menu.css";

export interface MenuItem {
  key: string;
  label: ReactNode;
  /** an <Icon /> */
  icon?: ReactNode;
  onClick: () => void;
  /** red text, e.g. Logout */
  danger?: boolean;
  /** extra class, e.g. "hideOnDesktop" */
  className?: string;
}

export interface MenuProps {
  items: MenuItem[];
  /** person or workspace at the top */
  title?: ReactNode;
  subtitle?: ReactNode;
  /** an <Avatar /> next to the title */
  avatar?: ReactNode;
  /** under the actions, e.g. a language switch */
  footer?: ReactNode;
  /** class on the footer box, e.g. "hideOnDesktop" to hide it with its line */
  footerClassName?: string;
  className?: string;
}

/**
 * Dropdown panel with actions. The page decides where it opens.
 * Example: <Menu title="Laura" items={[{ key: "out", label: "Logout", onClick }]} />
 */
const Menu = ({
  items,
  title,
  subtitle,
  avatar,
  footer,
  footerClassName = "",
  className = "",
}: MenuProps) => (
  <div className={`ds-menu ${className}`.trim()} role="menu">
    {(title || avatar) && (
      <div className="ds-menu__header">
        {avatar}
        <span className="ds-menu__who">
          {title && <span className="ds-menu__name">{title}</span>}
          {subtitle && <span className="ds-menu__email">{subtitle}</span>}
        </span>
      </div>
    )}
    {items.map((item) => (
      <button
        key={item.key}
        type="button"
        role="menuitem"
        className={`ds-menu__item ${item.danger ? "ds-menu__item--danger" : ""} ${
          item.className ?? ""
        }`.trim()}
        onClick={item.onClick}
      >
        {item.icon}
        {item.label}
      </button>
    ))}
    {footer && (
      <div className={`ds-menu__footer ${footerClassName}`.trim()}>
        {footer}
      </div>
    )}
  </div>
);

export default Menu;
